<template>
    <v-card :loading="loading" tile>
        <v-card-text>
            <v-list-item>
                <v-list-item-content>
                    <v-list-item-title>{{ t('audit-logs::grid.label.log_type') }}</v-list-item-title>
                    <v-list-item-subtitle>{{ t('audit-logs::labels.log_type.' + item.log_type) }}</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
            <v-list-item>
                <v-list-item-content>
                    <v-list-item-title>{{ t('audit-logs::grid.label.action_type') }}</v-list-item-title>
                    <v-list-item-subtitle>{{
                        t('audit-logs::labels.action_type.' + item.action_type)
                    }}</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="item.user">
                <v-list-item-content>
                    <v-list-item-title>{{ t('audit-logs::grid.label.user') }}</v-list-item-title>
                    <v-list-item-subtitle>{{ item.user.name }}</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
            <v-list-item>
                <v-list-item-content>
                    <v-list-item-title>{{ t('audit-logs::grid.label.action') }}</v-list-item-title>
                    <v-list-item-subtitle>{{ item.action }}</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
            <v-list-item>
                <v-list-item-content>
                    <v-list-item-title>{{ t('audit-logs::grid.label.uri') }}</v-list-item-title>
                    <v-list-item-subtitle>{{ item.uri }}</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
            <v-list-item>
                <v-list-item-content>
                    <v-list-item-title>{{ t('audit-logs::grid.label.method') }}</v-list-item-title>
                    <v-list-item-subtitle>{{ item.method }}</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="item.ip">
                <v-list-item-content>
                    <v-list-item-title>{{ t('audit-logs::grid.label.ip') }}</v-list-item-title>
                    <v-list-item-subtitle>{{ item.ip }}</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="item.user_agent">
                <v-list-item-content>
                    <v-list-item-title>{{ t('audit-logs::grid.label.user_agent') }}</v-list-item-title>
                    <v-list-item-subtitle>{{ item.user_agent }}</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
            <v-list-item>
                <v-list-item-content>
                    <v-list-item-title>{{ t('audit-logs::grid.label.response_code') }}</v-list-item-title>
                    <v-list-item-subtitle>{{ item.response_code }}</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
            <v-list-item>
                <v-list-item-content>
                    <v-list-item-title>{{ t('audit-logs::grid.label.created_at') }}</v-list-item-title>
                    <v-list-item-subtitle>{{
                        moment(item.created_at).format('DD.MM.YYYY hh:mm A')
                    }}</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="item.data">
                <v-list-item-content>
                    <v-list-item-title>{{ t('audit-logs::grid.label.data') }}</v-list-item-title>
                    <v-list-item-subtitle>
                        <pre class="small">{{ item.data | pretty }}</pre>
                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
        </v-card-text>
        <b-form-actions
            :id="id"
            :back-route="$root.route('audit-logs.index')"
            :has-save-button="false"
            :has-discard-button="false"
        ></b-form-actions>
    </v-card>
</template>

<script>
export default {
    filters: {
        pretty: function (value) {
            return JSON.stringify(value, null, 2);
        },
    },
    props: {
        id: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            loading: true,
            item: {
                log_type: 'audit',
                action_type: 'view',
                user_agent: null,
                response_code: null,
                created_at: null,
                method: null,
                user: {},
                acl_route: {},
            },
        };
    },
    created() {
        this.loadAuditLog();
    },
    methods: {
        loadAuditLog() {
            if (_.isEmpty(this.id)) {
                this.loading = false;
                return;
            }

            axios
                .get(route('api.v1.audit-logs.show', { audit_log: this.id, fields: '*,action,user.name' }))
                .then((response) => {
                    this.item = response.data.data;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>
